(function($) {
	'use strict';

	$(".submit-link").click(function () {
	    console.log("here");
	    $(this).closest("form").submit();
	});

})($jq);
